module.exports = __webpack_public_path__ + "static/media/for-investors-second.5f3cca36.jpg";